module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "features features-home"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-full"
  }, [_c('div', {
    staticClass: "tab-content-main"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-two-thirds has-text-left"
  }, [_c('div', {
    staticClass: "start-info"
  }, [_c('div', {
    staticClass: "title-mining"
  }, [_c('span', [_vm._v("Start ")]), _c('span', {
    staticClass: "pink"
  }, [_vm._v("earn")]), _c('span', [_vm._v("ing ")]), _c('coin-switcher', {
    on: {
      "selected": _vm.selectCoinFromSwitcher
    }
  })], 1), (_vm.isDelisted) ? _c('div', {
    staticClass: "info-block"
  }, [_c('p'), _vm._m(0), _c('p')]) : _vm._e(), (!_vm.isDelisted) ? _c('div', {
    staticClass: "info-block"
  }, [_c('div', [_c('span', [_vm._v("All you need to get started is ")]), _c('b', [_vm._v("your PC ")]), _c('span', [_vm._v(" and ")]), ('aeiou'.split('').indexOf(((_vm.coin && _vm.coin[0]) || '').toLowerCase()) > -1) ? _c('span', [_vm._v("an ")]) : _c('span', [_vm._v("a ")]), _c('b', [_vm._v(_vm._s(_vm.coin) + " ")]), _c('span', [_vm._v(" address!")])])]) : _vm._e(), (!_vm.isDelisted) ? _c('div', {
    staticClass: "info-block"
  }, [(_vm.isLoadingCoinData || _vm.chainsCoin.length === 1) ? [_c('span', [_vm._v("Free payouts from  ")]), (_vm.isLoadingCoinData) ? _c('b', {
    staticClass: "w_min_amount"
  }, [_c('i', {
    staticClass: "fa fa-circle-o-notch fa-spin"
  })]) : _c('b', [_c('span', [_vm._v(_vm._s(_vm._f("thousandComma")(_vm.chainsCoin[0].payment_threshold)) + " " + _vm._s(_vm.coin) + " (" + _vm._s(_vm.chainsCoin[0].token_standard || _vm.chainsCoin[0].network) + ")")])])] : [_c('div', [_c('span', [_vm._v("Supported payment chains: ")]), _vm._l((_vm.chainsCoin), function(o, index) {
    return _c('b', [_c('span', [_vm._v(_vm._s(o.network) + " (" + _vm._s(o.token_standard) + ")")]), (index !== _vm.chainsCoin.length - 1) ? _c('span', [_vm._v(", ")]) : _vm._e()])
  }), _c('span', [_vm._v(".")])], 2), _c('div', [_c('span', [_vm._v("The minimum payment threshold is ")]), _vm._l((_vm.chainsCoin), function(o, index) {
    return _c('span', [(index === _vm.chainsCoin.length - 1) ? _c('span', [_vm._v(" and ")]) : _vm._e(), _c('b', [_vm._v(_vm._s(_vm._f("thousandComma")(o.payment_threshold)) + " " + _vm._s(_vm.coin) + " ")]), _c('span', [_vm._v("for the ")]), _c('b', [_vm._v(_vm._s(o.network) + " ")]), _c('span', [_vm._v("network")]), (index < _vm.chainsCoin.length - 2) ? _c('span', [_vm._v(", ")]) : _vm._e(), (index === _vm.chainsCoin.length - 1) ? _c('span', [_vm._v(".")]) : _vm._e()])
  })], 2), _vm._m(1)], (_vm.highRiskCoin) ? _c('div', {
    staticClass: "high_risk"
  }, [_c('span', [_vm._v(_vm._s(_vm.coin) + " is a  ")]), _c('b', [_vm._v("highly volatile asset")]), _c('span', [_vm._v(", daily mining rewards may be inconsistent due to large price fluctuations.")])]) : _vm._e()], 2) : _vm._e(), (_vm.newCoins.length || _vm.recentCoins.length > 1) ? _c('div', {
    staticClass: "info-block mt-20"
  }, [_c('span', [_vm._v("Or explore other coins or tokens:")]), _c('div', {
    staticClass: "newest-list"
  }, [_vm._l((_vm.recentCoins), function(i) {
    return (i.symbol != _vm.coin) ? _c('div', {
      staticClass: "new-coin hint--bottom-right",
      class: {
        'is-loading': _vm.loadingCoin === i.symbol
      },
      attrs: {
        "aria-label": i.name + ' (' + i.symbol + ')'
      },
      on: {
        "click": function($event) {
          return _vm.selectNewCoin(i)
        }
      }
    }, [(i.top === 1) ? _c('div', {
      staticClass: "new-tag"
    }) : (i.delisted === 1) ? _c('div', {
      staticClass: "new-tag delisted"
    }) : _vm._e(), (_vm.loadingCoin === i.symbol) ? _c('div', {
      staticClass: "new-coin-loading"
    }, [_c('i', {
      staticClass: "fa fa-circle-o-notch fa-spin"
    })]) : _vm._e(), _c('div', {
      staticClass: "new-coin-logo"
    }, [_c('img', {
      attrs: {
        "src": i.logo
      }
    })])]) : _vm._e()
  }), (_vm.newCoins.length && _vm.recentCoins.length > 1) ? _c('div', {
    staticClass: "new-coin-separator"
  }) : _vm._e(), _vm._l((_vm.newCoins), function(i) {
    return (i.symbol != _vm.coin) ? _c('div', {
      staticClass: "new-coin hint--bottom-right",
      class: {
        'is-loading': _vm.loadingCoin === i.symbol
      },
      attrs: {
        "aria-label": i.name + ' (' + i.symbol + ')'
      },
      on: {
        "click": function($event) {
          return _vm.selectNewCoin(i)
        }
      }
    }, [(i.top === 1) ? _c('div', {
      staticClass: "new-tag"
    }) : (i.delisted === 1) ? _c('div', {
      staticClass: "new-tag delisted"
    }) : _vm._e(), (_vm.loadingCoin === i.symbol) ? _c('div', {
      staticClass: "new-coin-loading"
    }, [_c('i', {
      staticClass: "fa fa-circle-o-notch fa-spin"
    })]) : _vm._e(), _c('div', {
      staticClass: "new-coin-logo"
    }, [_c('img', {
      attrs: {
        "src": i.logo
      }
    })])]) : _vm._e()
  }), _c('div', {
    staticClass: "new-coin view-all",
    on: {
      "click": _vm.openCoinSwitcher
    }
  }, [_c('span', [_vm._v("View all")]), _c('i', {
    staticClass: "fa fa-arrow-right"
  })])], 2)]) : _vm._e()])]), _c('div', {
    staticClass: "column is-one-third start-controls"
  }, [(_vm.selectedAlgorithm.isInOurEasyMiningApp || _vm.selectedAlgorithm.showInWizard) ? [_c('div', {
    staticClass: "button is-text get-started-button",
    on: {
      "click": function($event) {
        return _vm.$router.push('/start')
      }
    }
  }, [_c('b', [_vm._v("Get started 🚀 🧙‍♂️")])]), _vm._m(2)] : _vm._e(), (!_vm.selectedAlgorithm.isInOurEasyMiningApp && !_vm.selectedAlgorithm.showInWizard && _vm.selectedAlgorithm.type === 'ASIC') ? [_c('div', {
    staticClass: "button is-text get-started-button",
    on: {
      "click": function($event) {
        return _vm.$router.push('/support?search=ASIC')
      }
    }
  }, [_c('b', [_vm._v("Get started 🚀")])]), _c('div', {
    staticClass: "small-desc-control"
  }, [_vm._v("Try our configuration tutorials & docs")])] : _vm._e()], 2)]), _c('news', {
    staticClass: "in-coin-news",
    attrs: {
      "pinnedOnly": true
    }
  })], 1), _vm._m(3), _c('algorithm-tabs', {
    attrs: {
      "selectedAlgorithm": _vm.selectedAlgorithm
    },
    on: {
      "selected": _vm.selectAlgorithm
    }
  }), _c('div', {
    staticClass: "tab-content-main"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-one-third is-hidden-mobile"
  }, [_c('PlatformStats'), _c('news'), _vm._m(4)], 1), _c('div', {
    staticClass: "column is-one-third",
    class: {
      'has-opacity': _vm.selectedAlgorithm.deactivated
    }
  }, [_c('div', {
    staticClass: "info-miner w100"
  }, [_c('div', {
    staticClass: "has-text-centered"
  }, [_c('div', {
    staticClass: "starter-text is-hidden-tablet-only is-hidden-desktop-only is-hidden-widescreen-only is-hidden-fullhd"
  }, [(_vm.selectedAlgorithm.extraComment) ? _c('div', {
    staticClass: "mb-10"
  }, [_vm._v(_vm._s(_vm.selectedAlgorithm.extraComment))]) : _vm._e(), (_vm.selectedAlgorithm.symbolDesc != _vm.coin) ? [_c('div', [_c('span', [_vm._v("When you use the  ")]), _c('b', [_vm._v(_vm._s(_vm.selectedAlgorithm.name) + " ")]), _c('span', [_vm._v("algorithm we automatically convert  ")]), _c('b', [_vm._v(_vm._s(_vm.selectedAlgorithm.symbolDesc) + " ")]), (_vm.selectedAlgorithm.symbolDesc === _vm.selectedAlgorithm.symbol) ? _c('img', {
    attrs: {
      "src": _vm.selectedAlgorithm.symbolLogo
    }
  }) : _vm._e(), _c('span', [_vm._v(" to  ")]), _c('b', [_vm._v(_vm._s(_vm.coin) + " ")]), _c('img', {
    attrs: {
      "src": _vm.coinLogo,
      "alt": _vm.coin + ' logo'
    }
  }), _c('span', [_vm._v(" on each reward and credit it to your address.")])])] : [_c('div', [_c('span', [_vm._v("When you use the  ")]), _c('b', [_vm._v(_vm._s(_vm.selectedAlgorithm.name) + " ")]), _c('span', [_vm._v("algorithm we automatically credit  ")]), _c('b', [_vm._v(_vm._s(_vm.coin) + " ")]), _c('span', [_vm._v(" to your address")])])]], 2), _c('div', {
    staticClass: "starter-text"
  }, [_c('span', [_vm._v("To get started with the  ")]), _c('b', [_vm._v(_vm._s(_vm.selectedAlgorithm.name) + " ")]), _c('span', [_vm._v(" algorithm simply point your worker(s) to our pool:")])]), _c('br'), (_vm.selectedAlgorithm) ? _c('div', {
    staticClass: "miner-pool"
  }, [_c('div', {
    staticClass: "pool-box"
  }, [_c('div', {
    staticClass: "pool-desc"
  }, [_vm._v(_vm._s(_vm.selectedAlgorithm.globalServer.description))]), _c('div', {
    staticClass: "pool-url",
    on: {
      "click": function($event) {
        return _vm.copyPoolToClipboard(_vm.selectedAlgorithm.globalServer.url)
      }
    }
  }, [_vm._v(_vm._s(_vm.selectedAlgorithm.globalServer.url))]), (_vm.selectedAlgorithm.globalServer.alternativePorts && _vm.selectedAlgorithm.globalServer.alternativePorts.length > 0 && _vm.selectedAlgorithm.code !== 'kheavyhash') ? _c('div', {
    staticClass: "pool-url-alt"
  }, [_c('span', {
    staticClass: "w400"
  }, [_vm._v("SSL Port")]), (_vm.selectedAlgorithm.globalServer.sslPorts.length > 1) ? _c('span', [_vm._v("s ")]) : _vm._e(), _c('span', [_vm._v(": ")]), _vm._l((_vm.selectedAlgorithm.globalServer.sslPorts), function(p, index) {
    return [_c('span', {
      staticClass: "pool-url-port",
      on: {
        "click": function($event) {
          return _vm.copyPoolToClipboard('stratum+ssl://' + _vm.selectedAlgorithm.globalServer.url + ':' + p)
        }
      }
    }, [_vm._v(_vm._s(p))]), (index < _vm.selectedAlgorithm.globalServer.sslPorts.length - 2) ? _c('span', [_vm._v(", ")]) : _vm._e(), (index === _vm.selectedAlgorithm.globalServer.sslPorts.length - 2) ? _c('span', [_vm._v(" & ")]) : _vm._e()]
  })], 2) : _vm._e(), (_vm.selectedAlgorithm.globalServer.sslPorts && _vm.selectedAlgorithm.globalServer.sslPorts.length > 0 && _vm.selectedAlgorithm.code !== 'kheavyhash') ? _c('div', {
    staticClass: "pool-url-alt"
  }, [_c('span', {
    staticClass: "w400"
  }, [_vm._v("TCP Port")]), (_vm.selectedAlgorithm.globalServer.alternativePorts.length > 1) ? _c('span', [_vm._v("s ")]) : _vm._e(), _c('span', [_vm._v(": ")]), _vm._l((_vm.selectedAlgorithm.globalServer.alternativePorts), function(p, index) {
    return [_c('span', {
      staticClass: "pool-url-port",
      on: {
        "click": function($event) {
          return _vm.copyPoolToClipboard('stratum+tcp://' + _vm.selectedAlgorithm.globalServer.url + ':' + p)
        }
      }
    }, [_vm._v(_vm._s(p))]), (index < _vm.selectedAlgorithm.globalServer.alternativePorts.length - 2) ? _c('span', [_vm._v(", ")]) : _vm._e(), (index === _vm.selectedAlgorithm.globalServer.alternativePorts.length - 2) ? _c('span', [_vm._v(" & ")]) : _vm._e()]
  })], 2) : _vm._e(), (_vm.selectedAlgorithm.globalServer.highDiffPorts && _vm.selectedAlgorithm.globalServer.highDiffPorts.length > 0) ? _c('div', {
    staticClass: "pool-url-alt"
  }, [_c('span', {
    staticClass: "w400"
  }, [_vm._v("High Diff Port")]), (_vm.selectedAlgorithm.globalServer.highDiffPorts.length > 1) ? _c('span', [_vm._v("s ")]) : _vm._e(), _c('span', [_vm._v(": ")]), _vm._l((_vm.selectedAlgorithm.globalServer.highDiffPorts), function(p, index) {
    return [_c('span', {
      staticClass: "pool-url-port",
      on: {
        "click": function($event) {
          _vm.copyPoolToClipboard('stratum+' + (p.ssl ? 'ssl' : 'tcp') + '://' + _vm.selectedAlgorithm.globalServer.url + ':' + p.port)
        }
      }
    }, [_vm._v(_vm._s(p.port) + " (" + _vm._s(p.ssl ? 'SSL' : 'TCP') + ")")]), (index < _vm.selectedAlgorithm.globalServer.highDiffPorts.length - 2) ? _c('span', [_vm._v(", ")]) : _vm._e(), (index === _vm.selectedAlgorithm.globalServer.highDiffPorts.length - 2) ? _c('span', [_vm._v(" & ")]) : _vm._e()]
  })], 2) : _vm._e(), _vm._l((_vm.selectedAlgorithm.globalServer.extraPorts), function(ep) {
    return (_vm.selectedAlgorithm.globalServer.extraPorts && _vm.selectedAlgorithm.globalServer.extraPorts.length > 0) ? _c('div', {
      staticClass: "pool-url-alt"
    }, [_c('span', {
      staticClass: "w400"
    }, [_vm._v(_vm._s(ep.name) + ": ")]), _vm._l((ep.ports), function(p, index) {
      return [_c('span', {
        staticClass: "pool-url-port",
        on: {
          "click": function($event) {
            _vm.copyPoolToClipboard('stratum+' + (p.ssl ? 'ssl' : 'tcp') + '://' + _vm.selectedAlgorithm.globalServer.url + ':' + p.number)
          }
        }
      }, [_c('span', [_vm._v(_vm._s(p.number) + " ")]), (ep.showType) ? _c('span', [_vm._v("(" + _vm._s(p.ssl ? 'SSL' : 'TCP') + ")")]) : _vm._e()]), (index < ep.ports.length - 2) ? _c('span', [_vm._v(", ")]) : _vm._e(), (index === ep.ports.length - 2) ? _c('span', [_vm._v(" & ")]) : _vm._e()]
    })], 2) : _vm._e()
  })], 2), _c('div', {
    staticClass: "pool-selection"
  }, [_c('span', [_vm._v("By using the global server we will auto select the closest server to your location, however you can still  ")]), _c('a', {
    staticClass: "toggle-global-server",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.isShowingAlternativeServers = !_vm.isShowingAlternativeServers
      }
    }
  }, [_vm._v("manually set a server if you want")])]), (_vm.isShowingAlternativeServers) ? _c('div', {
    staticClass: "pool-global-selection"
  }, _vm._l((_vm.selectedAlgorithm.alternativeServers), function(o) {
    return _c('div', {
      staticClass: "pool-box"
    }, [_c('div', {
      staticClass: "pool-desc"
    }, [_vm._v(_vm._s(o.description))]), _c('div', {
      staticClass: "pool-url",
      on: {
        "click": function($event) {
          return _vm.copyPoolToClipboard(o.url)
        }
      }
    }, [_vm._v(_vm._s(o.url))]), (o.sslPorts && o.sslPorts.length > 0 && _vm.selectedAlgorithm.code !== 'kheavyhash') ? _c('div', {
      staticClass: "pool-url-alt"
    }, [_c('span', {
      staticClass: "w400"
    }, [_vm._v("SSL Port")]), (o.sslPorts.length > 1) ? _c('span', [_vm._v("s ")]) : _vm._e(), _c('span', [_vm._v(": ")]), _vm._l((o.sslPorts), function(p, index) {
      return [_c('span', {
        staticClass: "pool-url-port",
        on: {
          "click": function($event) {
            return _vm.copyPoolToClipboard('stratum+ssl://' + o.url + ':' + p)
          }
        }
      }, [_vm._v(_vm._s(p))]), (index < o.sslPorts.length - 2) ? _c('span', [_vm._v(", ")]) : _vm._e(), (index === o.sslPorts.length - 2) ? _c('span', [_vm._v(" & ")]) : _vm._e()]
    })], 2) : _vm._e(), (o.alternativePorts && o.alternativePorts.length > 0 && _vm.selectedAlgorithm.code !== 'kheavyhash') ? _c('div', {
      staticClass: "pool-url-alt"
    }, [_c('span', {
      staticClass: "w400"
    }, [_vm._v("Alternative Port")]), (o.alternativePorts.length > 1) ? _c('span', {
      staticClass: "w400"
    }, [_vm._v("s ")]) : _vm._e(), _c('span', [_vm._v(": ")]), _vm._l((o.alternativePorts), function(p, index) {
      return [_c('span', {
        staticClass: "pool-url-port",
        on: {
          "click": function($event) {
            return _vm.copyPoolToClipboard('stratum+tcp://' + o.url + ':' + p)
          }
        }
      }, [_vm._v(_vm._s(p))]), (index < _vm.selectedAlgorithm.globalServer.alternativePorts.length - 2) ? _c('span', [_vm._v(", ")]) : _vm._e(), (index === _vm.selectedAlgorithm.globalServer.alternativePorts.length - 2) ? _c('span', [_vm._v(" & ")]) : _vm._e()]
    })], 2) : _vm._e(), (o.highDiffPorts && o.highDiffPorts.length > 0 && _vm.selectedAlgorithm.code !== 'kheavyhash') ? _c('div', {
      staticClass: "pool-url-alt"
    }, [_c('span', {
      staticClass: "w400"
    }, [_vm._v("High Diff Port")]), (o.highDiffPorts.length > 1) ? _c('span', [_vm._v("s ")]) : _vm._e(), _c('span', [_vm._v(": ")]), _vm._l((o.highDiffPorts), function(p, index) {
      return [_c('span', {
        staticClass: "pool-url-port",
        on: {
          "click": function($event) {
            _vm.copyPoolToClipboard('stratum+' + (p.ssl ? 'ssl' : 'tcp') + '://' + o.url + ':' + p.port)
          }
        }
      }, [_vm._v(_vm._s(p.port) + " (" + _vm._s(p.ssl ? 'SSL' : 'TCP') + ")")]), (index < o.highDiffPorts.length - 2) ? _c('span', [_vm._v(", ")]) : _vm._e(), (index === o.highDiffPorts.length - 2) ? _c('span', [_vm._v(" & ")]) : _vm._e()]
    })], 2) : _vm._e(), _vm._l((o.extraPorts), function(ep) {
      return (o.extraPorts && o.extraPorts.length > 0) ? _c('div', {
        staticClass: "pool-url-alt"
      }, [_c('span', {
        staticClass: "w400"
      }, [_vm._v(_vm._s(ep.name) + ": ")]), _vm._l((ep.ports), function(p, index) {
        return [_c('span', {
          staticClass: "pool-url-port",
          on: {
            "click": function($event) {
              _vm.copyPoolToClipboard('stratum+' + (p.ssl ? 'ssl' : 'tcp') + '://' + o.url + ':' + p.number)
            }
          }
        }, [_c('span', [_vm._v(_vm._s(p.number) + " ")]), (ep.showType) ? _c('span', [_vm._v("(" + _vm._s(p.ssl ? 'SSL' : 'TCP') + ")")]) : _vm._e()]), (index < ep.ports.length - 2) ? _c('span', [_vm._v(", ")]) : _vm._e(), (index === ep.ports.length - 2) ? _c('span', [_vm._v(" & ")]) : _vm._e()]
      })], 2) : _vm._e()
    })], 2)
  }), 0) : _vm._e()]) : _vm._e(), _c('br'), _c('span', [_vm._v("Be sure to set the user field with the coin you are mining, your address and your worker name:")]), _c('br'), _c('br'), _c('br'), _c('div', {
    staticClass: "miner-pool",
    attrs: {
      "id": "informative-text"
    }
  }, [(_vm.informativeDivHeight > 80) ? _c('span', {
    staticClass: "hint--top-left hint--always",
    attrs: {
      "aria-label": "The asset symbol"
    }
  }, [_vm._v(_vm._s(_vm.coin))]) : _c('span', {
    staticClass: "hint--bottom-right hint--always",
    attrs: {
      "aria-label": "The asset symbol"
    }
  }, [_vm._v(_vm._s(_vm.coin))]), _c('b', [_vm._v(":")]), _c('span', {
    staticClass: "hint--top-right hint--always",
    attrs: {
      "aria-label": 'Your ' + _vm.coin + ' address'
    }
  }, [_vm._v("YourAddress")]), _c('b', [_vm._v(".")]), _c('span', {
    staticClass: "hint--bottom hint--always",
    attrs: {
      "aria-label": "A worker name is required!"
    }
  }, [_vm._v("YourWorkerName")])]), _c('br'), _c('br'), _c('span', [_vm._v("...and start mining!")]), _c('br'), _c('br'), _c('div', {
    staticClass: "referral-template-home"
  }, [(_vm.referralCode) ? [_c('span', [_vm._v("You have been  ")]), _c('b', [_vm._v(" referred by another miner!  ")]), _c('span', [_vm._v("  you can ")]), _c('u', [_vm._v(" lower your mining fee to 0.75% ")]), _c('span', [_vm._v(", just add the following code after your worker name, separated by a  ")]), _c('b', [_vm._v(" #  ")]), _c('span', [_vm._v(" symbol:")])] : [_c('span', [_vm._v("If you have a  ")]), _c('b', [_vm._v(" Referral Code  ")]), _c('span', [_vm._v("  you can ")]), _c('u', [_vm._v(" lower your mining fee to 0.75% ")]), _c('span', [_vm._v(", just add it after your worker name, separated by a  ")]), _c('b', [_vm._v(" #  ")]), _c('span', [_vm._v(" symbol:")])], _c('br'), _c('br'), _c('div', {
    staticClass: "miner-pool"
  }, [_c('span', {
    staticClass: "hint--top pointable",
    attrs: {
      "aria-label": "The asset symbol"
    }
  }, [_vm._v(_vm._s(_vm.coin))]), _c('b', [_vm._v(":")]), _c('span', {
    staticClass: "hint--top pointable",
    attrs: {
      "aria-label": 'Your ' + _vm.coin + ' address'
    }
  }, [_vm._v("Address")]), _c('b', [_vm._v(".")]), _c('span', {
    staticClass: "hint--top pointable",
    attrs: {
      "aria-label": "A worker name is required!"
    }
  }, [_vm._v("Worker")]), _c('b', [_vm._v("#")]), _c('span', {
    staticClass: "hint--top pointable memo-",
    attrs: {
      "aria-label": "An optional Referral code!"
    }
  }, [_vm._v(_vm._s(_vm.referralCode || 'referral-code'))])]), _c('br'), _c('span', [_vm._v("(*) The referral code won't change your worker's name in your stats page.")]), _c('br'), _c('br'), _c('span', [_vm._v("Learn more about  ")]), _c('b', [_c('router-link', {
    attrs: {
      "to": "/referrals"
    }
  }, [_vm._v(" the commissions and benefits of having / sharing a referral code here!")])], 1)], 2), (_vm.isMemoCoin) ? [_c('br'), _c('div', {
    staticClass: "memo-template-home"
  }, [_c('span', [_vm._v("If you are  ")]), _c('b', [_vm._v(" mining to an exchange or need to set a MEMO or TAG  ")]), _c('span', [_vm._v(" you must add it after your address:")]), _c('br'), _c('br'), _c('div', {
    staticClass: "miner-pool"
  }, [_c('span', {
    staticClass: "hint--top pointable",
    attrs: {
      "aria-label": "The asset symbol"
    }
  }, [_vm._v(_vm._s(_vm.coin))]), _c('b', [_vm._v(":")]), _c('span', {
    staticClass: "hint--top pointable",
    attrs: {
      "aria-label": 'Your ' + _vm.coin + ' address'
    }
  }, [_vm._v("YourAddress")]), _c('b', [_vm._v(":")]), _c('span', {
    staticClass: "hint--top pointable memo-",
    attrs: {
      "aria-label": 'Your ' + _vm.coin + ' memo or tag'
    }
  }, [_vm._v("YourMemo")]), _c('b', [_vm._v(".")]), _c('span', {
    staticClass: "hint--top pointable",
    attrs: {
      "aria-label": "A worker name is required!"
    }
  }, [_vm._v("YourWorkerName")])])])] : _vm._e()], 2)])]), _c('div', {
    staticClass: "column is-one-third"
  }, [_c('div', {
    staticClass: "info-miner w100"
  }, [_c('div', [(_vm.selectedAlgorithm.isInOurEasyMiningApp) ? [_vm._m(5), _c('div', {
    staticClass: "guides mb-13"
  }, [_c('router-link', {
    staticClass: "mining-guide",
    attrs: {
      "to": "/miner"
    }
  }, [_c('div', {
    staticClass: "flex-1"
  }, [_c('span', [_vm._v("How to setup  ")]), _c('b', {
    staticClass: "w400"
  }, [_vm._v("Our easy mining app")])]), _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-external-link"
  })])])], 1)] : _vm._e(), (_vm.selectedAlgorithm.showInWizard) ? [_vm._m(6), _c('div', {
    staticClass: "guides"
  }, [_c('router-link', {
    staticClass: "mining-guide",
    attrs: {
      "to": "/wizard"
    }
  }, [_c('div', {
    staticClass: "flex-1"
  }, [_c('span', [_vm._v("Get started with ")]), _c('b', {
    staticClass: "w400"
  }, [_vm._v("our Guided Setup")])]), _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-external-link"
  })])])], 1)] : _vm._e(), _c('p', {
    staticClass: "has-text-left",
    class: {
      'mt-13': _vm.selectedAlgorithm.showInWizard
    }
  }, [(_vm.selectedAlgorithm.showInWizard) ? _c('span', [_vm._v("Or follow ")]) : _c('span', [_vm._v("You can also get started by following ")]), (_vm.selectedAlgorithm.guides.length > 1) ? _c('span', [_vm._v("one of our more advanced setup guides:")]) : _c('span', [_vm._v("our more advanced setup guide:")])]), _c('div', {
    staticClass: "guides"
  }, _vm._l((_vm.selectedAlgorithm.guides), function(o, index) {
    return _c('router-link', {
      key: 'guide' + index,
      staticClass: "mining-guide",
      attrs: {
        "to": o.relativeUrl
      }
    }, [_c('div', {
      staticClass: "flex-1"
    }, [_c('span', [_vm._v("Get started with ")]), _c('b', {
      staticClass: "w400"
    }, [_vm._v(" " + _vm._s(o.name))])]), _c('span', {
      staticClass: "icon"
    }, [_c('i', {
      staticClass: "fa fa-external-link"
    })])])
  }), 1), _c('div', {
    staticClass: "search-coin-home is-hidden-touch"
  }, [_c('hr'), _c('p', [_vm._v("Enter your address to check your stats:")]), _c('br'), _c('div', {
    staticClass: "field field-address field-address-home has-addons"
  }, [_c('div', {
    staticClass: "control is-medium is-expanded"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.address),
      expression: "address"
    }],
    staticClass: "input is-medium address_input_home",
    attrs: {
      "type": "text",
      "placeholder": 'Your ' + _vm.coin + ' address'
    },
    domProps: {
      "value": (_vm.address)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.goToAddress.apply(null, arguments)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.address = $event.target.value
      }
    }
  })]), _c('div', {
    staticClass: "control find_address_home"
  }, [_c('a', {
    staticClass: "button is-success is-medium",
    on: {
      "click": _vm.goToAddress
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])])]), (_vm.isMemoCoin) ? _c('div', {
    staticClass: "label-calculate mt-5"
  }, [_c('span', [_vm._v("If you are using a payment tag or memo search by: ")]), _c('span', {
    staticClass: "w400"
  }, [_vm._v(" YourAddress")]), _c('b', {
    staticClass: "margin-memo-text w400"
  }), _c('span', {
    staticClass: "w400"
  }, [_vm._v("YourMemo")])]) : _vm._e()]), _c('news', {
    staticClass: "is-hidden-tablet-only is-hidden-desktop-only is-hidden-widescreen-only is-hidden-fullhd"
  }), _c('hr'), _c('calculator', {
    ref: "calculator",
    attrs: {
      "selectedAlgorithm": _vm.selectedAlgorithm,
      "coin": _vm.coin
    }
  })], 2), _vm._m(7)])])])])], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('span', {
    staticClass: "delisted-disclaimer"
  }, [_vm._v("This coin or token has been delisted and no further rewards will be credited.")]), _c('br'), _c('span', [_vm._v("For more information kindly check the News section or our ")]), _c('a', {
    attrs: {
      "href": "https://x.com/un_mineable",
      "target": "_blank"
    }
  }, [_vm._v(" official X feed.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mt-10"
  }, [_c('span', [_vm._v("Compatible payment networks can be switched at any time.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "small-desc-control has-text-centered"
  }, [_c('span', [_vm._v("Try the ")]), _c('span', {
    staticClass: "w400"
  }, [_vm._v("unMiner ")]), _c('span', [_vm._v(" desktop app or our guided setup!")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tab-content-main"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column has-text-left"
  }, [_c('div', {
    staticClass: "or-element"
  }, [_c('div', {
    staticClass: "inner-or-element"
  }, [_c('span', [_vm._v("Or ")]), _c('span', {
    staticClass: "w400"
  }, [_vm._v(" manually setup ")]), _c('span', [_vm._v("your workers and point to one of our ")]), _c('span', {
    staticClass: "w400"
  }, [_vm._v(" compatible algorithm pools")])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "info-miner w100"
  }, [_c('hr'), _c('p', [_vm._v("If you have any issue, question or suggestion contact us here:")]), _c('br'), _c('div', {
    staticClass: "mb-10"
  }, [_c('div', [_vm._v("Email (Official Support Channel)")]), _c('a', {
    staticClass: "social-link",
    attrs: {
      "href": "mailto:support@unmineable.com"
    }
  }, [_c('b', [_vm._v("support@unmineable.com")])])]), _c('div', {
    staticClass: "mb-10"
  }, [_c('div', [_vm._v("X (formerly Twitter)")]), _c('a', {
    staticClass: "social-link",
    attrs: {
      "href": "https://x.com/un_mineable",
      "target": "_blank"
    }
  }, [_c('b', [_vm._v("@un_mineable")])])]), _c('div', {
    staticClass: "mb-10"
  }, [_c('div', [_vm._v("Instagram")]), _c('a', {
    staticClass: "social-link",
    attrs: {
      "href": "https://instagram.com/unminable",
      "target": "_blank"
    }
  }, [_c('b', [_vm._v("@unminable")])])]), _c('div', {
    staticClass: "mt-15"
  }, [_c('span', [_vm._v("Beware of impersonators, we have no official Telegram or Discord channels.")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "has-text-left"
  }, [_c('span', [_vm._v("You can get started by using our easy mining desktop app:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "has-text-left"
  }, [_c('span', [_vm._v("You can also try our easy guided setup for third party apps:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "info-miner w100 is-hidden-tablet-only is-hidden-desktop-only is-hidden-widescreen-only is-hidden-fullhd"
  }, [_c('hr'), _c('p', [_vm._v("If you have any issue, question or suggestion contact us here:")]), _c('br'), _c('div', {
    staticClass: "mb-10"
  }, [_c('div', [_vm._v("Email (Official Support Channel)")]), _c('a', {
    staticClass: "social-link",
    attrs: {
      "href": "mailto:support@unmineable.com"
    }
  }, [_c('b', [_vm._v("support@unmineable.com")])])]), _c('div', {
    staticClass: "mb-10"
  }, [_c('div', [_vm._v("X (formerly Twitter)")]), _c('a', {
    staticClass: "social-link",
    attrs: {
      "href": "https://x.com/un_mineable",
      "target": "_blank"
    }
  }, [_c('b', [_vm._v("@un_mineable")])])]), _c('div', {
    staticClass: "mb-10"
  }, [_c('div', [_vm._v("Instagram")]), _c('a', {
    staticClass: "social-link",
    attrs: {
      "href": "https://instagram.com/unminable",
      "target": "_blank"
    }
  }, [_c('b', [_vm._v("@unminable")])])]), _c('div', {
    staticClass: "mt-15"
  }, [_c('span', [_vm._v("Beware of impersonators, we have no official Telegram or Discord channels.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6f3f46aa","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/View_Coin.vue
// module id = 383
// module chunks = 1